<!-- ColorPicker.vue -->
<template>
  <div class="app-wrapper">
    <header class="top-header">
      <div class="header-brand">
        <div class="brand-mark">T</div>
        <div class="brand-info">
          <span class="brand-name">thxily</span>
          <span class="brand-sub">管理コンソール</span>
        </div>
      </div>
      <button class="back-btn" v-on:click="back">← メニューへ戻る</button>
    </header>
    <main class="main-content">
      <div class="white-card">
        <h2 class="page-title">ヘッダ編集</h2>
        <form id="form" v-on:submit.prevent="dummy">
          <div class="form-group">
            <div class="image-container" v-if="fileInfo !== ''">
              <img :src="fileInfo" class="preview-img" :style="{ width: imageSize.width, height: imageSize.height }"/>
            </div>
            <div class="mt-16">
              <input type="file" v-on:change="fileSelected"/>
            </div>
          </div>
          <div class="form-group">
            <label class="form-label">メインカラー</label>
            <input type="color" v-model="selectedColor" @input="updateColor" class="color-input"/>
          </div>
          <div class="form-group">
            <label class="form-label">サブカラー</label>
            <input type="color" v-model="selectedSubColor" @input="updateSubColor" class="color-input"/>
          </div>
          <div class="btn-row">
            <button v-on:click="update" class="btn-primary">更新</button>
            <button v-on:click="back" class="btn-secondary">戻る</button>
          </div>
        </form>
      </div>
    </main>
  </div>
</template>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@400;500;700&display=swap');

.app-wrapper {
  min-height: 100vh;
  background: #DDE2EC;
  font-family: 'Noto Sans JP', 'Segoe UI', sans-serif;
}

.top-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 32px;
  height: 64px;
  background: #1E2A3A;
  box-shadow: 0 2px 8px rgba(0,0,0,0.2);
}

.header-brand { display: flex; align-items: center; gap: 12px; }

.brand-mark {
  width: 38px; height: 38px; border-radius: 10px;
  background: linear-gradient(135deg, #4F8EF7, #7C5CFC);
  display: flex; align-items: center; justify-content: center;
  font-size: 1.1rem; font-weight: 800; color: #fff;
}

.brand-info { display: flex; flex-direction: column; line-height: 1.2; }
.brand-name { font-size: 1rem; font-weight: 700; color: #fff; }
.brand-sub  { font-size: 0.68rem; color: #8A9BB0; }

.back-btn {
  padding: 8px 20px; border-radius: 8px;
  border: 1.5px solid #94A3B8; background: transparent;
  color: #94A3B8; font-size: 0.85rem; font-weight: 600;
  cursor: pointer; font-family: inherit;
  transition: background 0.2s, color 0.2s;
}
.back-btn:hover { background: #94A3B8; color: #1E2A3A; }

.main-content {
  max-width: 960px; margin: 0 auto;
  padding: 40px 24px 80px;
}

.white-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.10);
  padding: 32px 40px;
}

.page-title {
  font-size: 1.3rem; font-weight: 700;
  color: #1E293B; margin: 0 0 24px 0;
  padding-bottom: 12px;
  border-bottom: 2px solid #E2E8F0;
}

.form-group { margin-bottom: 20px; }

.form-label {
  display: block; font-size: 0.85rem; font-weight: 600;
  color: #475569; margin-bottom: 6px;
}

.color-input {
  width: 60px; height: 36px;
  border: 1.5px solid #CBD5E1; border-radius: 6px;
  cursor: pointer; padding: 2px;
}

.image-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 12px;
}

.preview-img {
  border-radius: 8px;
  border: 1.5px solid #E2E8F0;
}

.mt-16 { margin-top: 16px; }

.btn-row {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.btn-primary {
  padding: 10px 24px; border-radius: 8px; border: none;
  background: #3B82F6; color: #fff;
  font-size: 0.9rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: background 0.2s;
}
.btn-primary:hover { background: #2563EB; }

.btn-secondary {
  padding: 10px 24px; border-radius: 8px;
  border: 1.5px solid #CBD5E1; background: #fff;
  color: #475569; font-size: 0.9rem; font-weight: 600;
  cursor: pointer; font-family: inherit; transition: background 0.2s;
}
.btn-secondary:hover { background: #F1F5F9; }
</style>
<script>
import axios from "axios";
import router from "@/router";
export default {
  props: {
    value: {
      type: String, // 親コンポーネントからのバリデーションを追加することができます
      default: '#ffffff', // 初期色
    },
    imageSize: {
      type: Object,
      default: () => ({ width: '300px', height: 'auto' }), // Set default size here
    },
  },
  async mounted() {
    this.get();
  },
  data() {
    return {
      selectedColor: this.value,
      selectedSubColor: this.value,
      fileSetted: false,
      fileInfo: '',
      fileInfo2: '',
      base64Image: '',
    };
  },
  methods: {
    dummy: function () {
    },
    get: function () {
      axios.get("/tenant_branding").then((response) => {
        if (response.data.logo) {
          this.fileInfo = "data:image/png;base64," + response.data.logo;
        }
        if (response.data.main_color) {
          this.selectedColor = response.data.main_color;
          this.selectedSubColor = response.data.sub_color;
        }
      });
    },
    convertToBase64(file) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result.split(",")[1];
        // base64Stringを使って何かを行うか、stateにセットするなどの処理を行う
        this.base64Image = base64String;
      };
      reader.readAsDataURL(file);
    },
    updateColor() {
      console.log(this.selectedColor);
      this.$emit('input', this.selectedColor);
    },
    updateSubColor() {
      console.log(this.selectedSubColor);
      this.$emit('input', this.selectedSubColor);
    },
    fileSelected: function (event) {
      // Assuming you want to display the selected image
      const file = event.target.files[0];
      this.fileInfo = URL.createObjectURL(file);
      this.fileSetted = true;
      this.convertToBase64(file);
    },
    update: function () {
      const data = {
        file: this.base64Image,
        main_color: this.selectedColor,
        sub_color: this.selectedSubColor,
      };
      const formData = new FormData()
      // formData.append('file', this.fileInfo)
      formData.append('main_color', this.selectedColor)
      formData.append('sub_color', this.selectedSubColor)

      axios.post('/create_tenant_branding', data).then(response => {
        alert("更新しました。");
        router.push("/menu");
      });
    },
    back: function () {
      router.push("/menu")
    },
  },
};
</script>
